import { __awaiter, __generator } from "tslib";
import { getDriveItemContent } from './getDriveItemContent';
export function getUrlFileInfo(driveId, itemId, graphXhrOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var urlRegex, fileContent, matchGroups;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    urlRegex = /^URL=(.+)$/m;
                    return [4 /*yield*/, getDriveItemContent({
                            driveId: driveId,
                            itemId: itemId,
                            graphXhrOptions: graphXhrOptions,
                        })];
                case 1:
                    fileContent = _a.sent();
                    if (fileContent) {
                        matchGroups = fileContent.match(urlRegex);
                        if (matchGroups && matchGroups.length > 1) {
                            return [2 /*return*/, {
                                    address: matchGroups[1],
                                }];
                        }
                    }
                    return [2 /*return*/, undefined];
            }
        });
    });
}
//# sourceMappingURL=getUrlFileInfo.js.map